
import { useNavigate } from "react-router-dom";
import { useEnhancedPropBots } from "@/hooks/use-enhanced-prop-bots";
import { PropBotCard } from "@/components/prop-trading/PropBotCard";
import { PropBotToolbar } from "@/components/prop-trading/PropBotToolbar";
import { TourButton } from "@/components/common/TourButton";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";

const PropTradingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const {
    bots,
    isLoading,
    error,
    searchTerm,
    setSearchTerm,
    sortBy,
    setSortBy
  } = useEnhancedPropBots();

  if (error) {
    return <div className="container mx-auto">
        <p className="text-red-500">{t('error_fetching_data')}</p>
      </div>;
  }

  const handleBotAction = (botId: string) => {
    navigate(`/prop-trading/${botId}`);
  };

  return <div className={`mx-auto space-y-${isMobile ? "4" : "6"} ${isMobile ? 'pb-36' : ''}`}>
      <div className="space-y-2">
        <div className="flex items-center gap-2" data-tour="prop-trading-header">
          <h1 className={`${isMobile ? "text-xl" : "text-3xl"} font-bold`}>{t('prop_trading_bots')}</h1>
          <TourButton pageId="prop-trading" className="ml-1" />
        </div>
        <p className={`${isMobile ? "text-sm" : ""} text-muted-foreground`}>
          {t('get_funded_description')}
        </p>
      </div>

      <PropBotToolbar 
        searchTerm={searchTerm} 
        onSearchChange={setSearchTerm} 
        sortBy={sortBy} 
        onSortChange={setSortBy} 
      />

      {isLoading ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map(i => <div key={i} className="h-[200px] rounded-lg bg-muted animate-pulse" />)}
        </div> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {bots.map(bot => <PropBotCard key={bot.id} bot={bot} onAction={() => handleBotAction(bot.id)} />)}
        </div>}
    </div>;
};

export default PropTradingPage;
